import React, { useState } from 'react';
import CheckboxMultiple from '../../atoms/CheckBoxMultiple';
import NCPListFilterQuery from 'ui/helpers/utils/NCPListFilterQuery';
import { encode } from 'querystring';
import { useRouter } from '../../../hooks/useCustomRouter';
import eventClickNCL from '../../../helpers/emarsys/new-car-list/eventClickNCL';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from '../../../store';
import { BUTTON_NAME_NEW_CAR_LIST } from '../../../constants/emarsys/new-car-list';
import { IBreadcrumbs } from '../../molecules/Breadcrumbs';

export interface FilterTransmisionProps {
  transmisionList: {
    name: string;
    query: {
      url: string;
    };
    selected: boolean;
  }[];
  impressionData?: {
    customerNo?: string;
    title?: string;
    carCategory?: string;
    carModel?: string;
    sectionName?: string;
    filterValue?: {
      price?: string;
      search?: string;
      color?: string;
      fuel_type?: string;
      transmission?: string;
      capacity?: string;
      tag?: string;
      order_by?: string;
    };
  };
  breadcrumbItems?: IBreadcrumbs[];
}

export default function FilterTransmision({
  transmisionList,
  impressionData,
  breadcrumbItems,
}: FilterTransmisionProps) {
  const router = useRouter();
  const [dataCheckbox, setDataCheckbox] = useState([]);
  const dispatch = useDispatch();
  const { userData } = useSelector((state: IRootState) => state.auth);

  const handleFilterChange = (e) => {
    const { value, checked } = e.target;
    const cleanedQuery = NCPListFilterQuery(value);
    const existingQueryParams = router.query;
    if (existingQueryParams?.q) {
      delete existingQueryParams.q;
    }
    const newUrl = `${new URLSearchParams(
      existingQueryParams ? encode(existingQueryParams) : ''
    ).toString()}`;

    const transmissionListTemp = transmisionList
      ?.filter((item) => item?.selected)
      ?.map((item) => {
        return item.name;
      });
    const valueCode = transmisionList?.find((item) => {
      const val = item?.query?.url.replace(/%3AbodyType%3A\w+/gi, '');
      return val.replace('/c/mobil-baru-toyota', router.pathname) === value;
    })?.name;
    eventClickNCL(
      dispatch,
      userData?.customerNo || '',
      impressionData?.title || '',
      impressionData?.carCategory || '',
      '',
      impressionData?.sectionName || '',
      BUTTON_NAME_NEW_CAR_LIST.TRANSMISI,
      breadcrumbItems,
      {
        ...impressionData.filterValue,
        transmission: checked
          ? [...transmissionListTemp, valueCode].join(',')
          : transmissionListTemp.filter((e) => e !== valueCode).join(','),
      }
    );

    if (newUrl === '') {
      router.push(cleanedQuery);
    } else {
      router.push(cleanedQuery + `&` + newUrl);
    }
    if (checked) {
      setDataCheckbox([...dataCheckbox, value]);
    } else {
      setDataCheckbox(dataCheckbox.filter((e) => e !== value));
    }
  };

  return (
    <div>
      {transmisionList?.map((item, _i) => {
        //remove bodytype query
        const val = item?.query?.url.replace(/%3AbodyType%3A\w+/gi, '');
        return (
          <CheckboxMultiple
            key={_i}
            label={item?.name}
            value={val.replace('/c/mobil-baru-toyota', router.pathname)}
            onChange={handleFilterChange}
            checked={item?.selected}
          />
        );
      })}
    </div>
  );
}
